<template>
  <div style=" width: 1200px; margin: 0 auto; background-color: #F2F6FC;  ">
<!--    <Title :title="route"></Title>-->

    <Setp :nodes="nodes" :audits="audits"></Setp>

    <el-card class="box-card" style="min-height: 650px;margin-top: 15px" shadow="never">
      <el-form label-position="left" label-width="150px">

        <el-divider content-position="left">申请人信息</el-divider>

        <el-form-item label="申请人" prop="">
          <el-input v-model="user.realName" readonly></el-input>
        </el-form-item>

        <el-form-item label="所属部门" prop="">
          <el-input v-model="user.deptName" readonly></el-input>
        </el-form-item>

        <el-divider content-position="left">实施信息</el-divider>

        <el-form-item label="所属项目">
          <el-input v-model="detail.projectName" readonly></el-input>
        </el-form-item>

        <el-form-item label="实施单位" prop="enforceCompany">
          <el-input v-model="detail.enforceCompany" readonly></el-input>
        </el-form-item>

        <el-form-item label="材料名称" prop="enforceName">
          <el-input v-model="detail.enforceName" readonly></el-input>
        </el-form-item>

        <el-form-item label="实施时间" prop="enforceTime">
          <el-date-picker
              readonly
              v-model="detail.enforceTime"
              value-format="yyyy-MM-dd HH:mm:ss"
              format="yyyy-MM-dd HH:mm"
              type="datetime"
              placeholder="请选择实施时间">
          </el-date-picker>
        </el-form-item>

        <el-form-item label="实施文件">
          <el-link type="primary" @click="download()">下载文件</el-link>
          <el-link style="margin-left: 8px" v-if="isPdf(detail.filePath)" type="primary" @click="viewPdf(detail.filePath)">预览</el-link>
        </el-form-item>
        <el-form-item label="备注" prop="remarks">
          <el-input type="textarea" rows="5" maxlength="500" show-word-limit readonly
                    v-model="detail.remarks"></el-input>
        </el-form-item>

        <AuditList :audits="audits" :auditHistory="auditHistory"></AuditList>
        <div v-if="allowAudit==true">
          <el-divider content-position="left">我要审批</el-divider>
          <el-form-item label="审批意见" prop="remarks">
            <el-input type="textarea" rows="5" maxlength="500" show-word-limit
                      v-model="ruleForm.auditOpinion"></el-input>
          </el-form-item>
          <el-Form-item>
            <el-button type="primary" @click="audit(2)">审核通过</el-button>
            <el-button type="danger" @click="audit(3)">审核拒绝</el-button>
          </el-Form-item>
        </div>
      </el-form>
    </el-card>
    <el-dialog :visible.sync="showPdf" :append-to-body="true" top="0" custom-class="pdf-viewer">
      <div style="width:100%; height:100%;">
        <iframe id="myIframe" :src="pdfurl" width="100%" height="900px"></iframe>
      </div>
    </el-dialog>
  </div>


</template>

<script>
import Title from "../../Title";
import {requestApplyDetail, requestAudit, requestAuditShow} from "../../../api";
import {minioServer, IsPdf} from "../../../util";
import AuditList from "../common/AuditList";
import Setp from "../common/Setp";

export default {
  components: {AuditList, Title, Setp},
  name: "EnforceDetail",
  props: {
    // 接收父组件传入的参数
    query: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      route: {
        name: '实施文件归档详情',
        path: ''
      },
      detail: {},
      audits: [],
      auditHistory: [],
      applyId: "",
      applyServiceId: "",
      applyType: "",
      user: {},
      ruleForm: {
        auditOpinion: "",
      },
      nodes: [],
      allowAudit: false,
      showPdf: false,
      pdfurl: ""
    }
  },
  created() {
    // this.route.path = this.$route.fullPath
    this.applyId = this.query.applyId
    this.applyServiceId = this.query.applyServiceId
    this.applyType = this.query.applyType
    this.getObject()
    this.getAuditShow()
  },
  methods: {
    download() {
      window.open(minioServer + this.detail.filePath)
    },
    getAuditShow() {
      requestAuditShow({
        applyId: this.applyId,
      }).then(res => {
        if (res.code == 200) {
          if (res.object) {
            if (res.object == 1) {
              this.allowAudit = true
            }
            if (res.object == 2) {
              this.allowAudit = false
            }
          }
        }
      })
    },
    audit(isAgree) {
      this.allowAudit = false

      if (isAgree == 2 && !this.ruleForm.auditOpinion) {
        this.ruleForm.auditOpinion = "同意"
      }
      if (isAgree == 3 && !this.ruleForm.auditOpinion) {
        this.ruleForm.auditOpinion = "不同意"
      }
      requestAudit({
        isAgree: isAgree,
        applyId: this.query.applyId,
        applyType: this.query.applyType,
        auditOpinion: this.ruleForm.auditOpinion,
      }).then(res => {
        if (res.code == 200) {
          this.getAuditShow()
          this.getObject()
          this.$message.success(res.msg);
        } else {
          this.$message.error(res.msg);
        }
      })
    },
    getObject() {
      requestApplyDetail({
        applyId: this.query.applyId,
        applyServiceId: this.query.applyServiceId,
        applyType: this.query.applyType
      }).then(res => {
        if (res.code == 200) {

          if (res.object) {
            this.detail = res.object.detail
            this.audits = res.object.audits
            this.auditHistory = res.object.auditHistory
            this.user = res.object.user
            this.nodes = res.object.nodes
          }
        } else {
          this.$message.error(res.msg);
        }
      })
    },
    viewPdf(path) {
      this.showPdf = true
      this.pdfurl = "/pdfjs/web/viewer.html?file=" + minioServer + path
    },
    isPdf(fileName) {
      return IsPdf(fileName)
    }
  }
}
</script>

<style>

</style>